module.exports = __webpack_public_path__ + "static/img/empty.b496d60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty.svg
// module id = 7p6U
// module chunks = 12